import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {provideTranslateService, TranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {AuthorizationInterceptor} from './interceptors/authorization.interceptor';
import {ExceptionInterceptor} from './interceptors/exception.interceptor';
import {EXCEPTION_HANDLER_TOKEN} from './tokens/exception-handler-token';
import {InternalServerErrorExceptionHandler} from './models/exception-handlers/internal-server-error.exception-handler';
import {NotFoundExceptionHandler} from './models/exception-handlers/not-found.exception-handler';
import {ConflictExceptionHandler} from './models/exception-handlers/conflict.exception-handler';
import {BadRequestExceptionHandler} from './models/exception-handlers/bad-request.exception-handler';
import {ContentTooLargeExceptionHandlerService} from './models/exception-handlers/content-too-large.exception-handler';
import {GoneExceptionHandler} from './models/exception-handlers/gone.exception-handler';
import {ServiceUnavailableExceptionHandler} from './models/exception-handlers/service-unavailable.exception-handler';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {PaginatorI18n} from './providers/PaginatorI18n';
import {TenantInterceptor} from './interceptors/tenant.interceptor';
import {LanguageInterceptor} from './interceptors/language.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: EXCEPTION_HANDLER_TOKEN, useClass: InternalServerErrorExceptionHandler, multi: true},
    {provide: EXCEPTION_HANDLER_TOKEN, useClass: NotFoundExceptionHandler, multi: true},
    {provide: EXCEPTION_HANDLER_TOKEN, useClass: ConflictExceptionHandler, multi: true},
    {provide: EXCEPTION_HANDLER_TOKEN, useClass: BadRequestExceptionHandler, multi: true},
    {provide: EXCEPTION_HANDLER_TOKEN, useClass: ContentTooLargeExceptionHandlerService, multi: true},
    {provide: EXCEPTION_HANDLER_TOKEN, useClass: GoneExceptionHandler, multi: true},
    {provide: EXCEPTION_HANDLER_TOKEN, useClass: ServiceUnavailableExceptionHandler, multi: true},
    // Angular applies interceptors in the order that you provide them.
    // https://angular.dev/guide/http/interceptors
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ExceptionInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TenantInterceptor,
      multi: true
    },
    provideZoneChangeDetection({eventCoalescing: true}), provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService(),
    provideTranslateHttpLoader({prefix: 'assets/i18n/', suffix: '.json'}),
    {
      provide: MatPaginatorIntl, deps: [TranslateService],
      useFactory: (translateService: TranslateService) => new PaginatorI18n(translateService).getPaginatorIntl()
    }
  ]
};
